<select 
  #mySelect
  name="mySelect"
  [(ngModel)]="optionSelected"
  (change)="onChange($event)">
  <!-- <option></option> -->
  <option *ngFor="let option of options"
          [ngValue]="option">{{getOption(option)}}</option>
</select>
